import React from 'react';
import styled from 'styled-components';

import { TippyDefault } from 'app/components/Tippy';
import Typography from 'app/components/Typography';

export enum ViewMode {
  list = 0,
  nonList = 1,
}

const Button = styled.div<{ isActive?: boolean }>`
  width: 43px;
  height: 43px;
  cursor: pointer;
  border-radius: 8px;
  z-index: 2;
  position: relative;
  :hover {
    svg path[stroke] {
      stroke: var(--primary);
    }
    background: var(--primary-3);
  }
  ${({ isActive }) =>
    isActive
      ? `svg path[stroke] {
            stroke: var(--primary);
        }`
      : ''}
`;

const Switch = styled.div<{ view: ViewMode }>`
  position: absolute;
  background: #d1eaff;
  width: 43px;
  height: 43px;
  border-radius: 8px;
  transition: all 0.3s;
  z-index: 1;
  left: ${({ view }) => (view === ViewMode.list ? 0 : 43)}px;
`;

const ButtonSwitchViewWrapper = styled.div`
  background: var(--neutral-2);
  border-radius: 8px;
  position: relative;
`;

interface Props {
  view: ViewMode;
  onClickButton: (view: ViewMode) => () => void;
  messages: string[];
  iconList: React.FC[];
}

const ButtonSwitchView: React.FC<Props> = ({ view, onClickButton, messages, iconList }) => {
  const IconLeft = iconList[0];
  const IconRight = iconList[1];

  return (
    <ButtonSwitchViewWrapper className="d-flex align-items-center">
      <TippyDefault
        arrow={true}
        placement="top"
        theme="dark"
        allowHTML
        content={
          <Typography variant="body-4" color="white">
            {messages[0]}
          </Typography>
        }
      >
        <Button
          onClick={onClickButton(ViewMode.list)}
          isActive={view === ViewMode.list}
          className="d-flex align-items-center justify-content-center"
        >
          <IconLeft />
        </Button>
      </TippyDefault>

      <TippyDefault
        arrow={true}
        placement="top"
        theme="dark"
        allowHTML
        content={
          <Typography variant="body-4" color="white">
            {messages[1]}
          </Typography>
        }
      >
        <Button
          onClick={onClickButton(ViewMode.nonList)}
          isActive={view === ViewMode.nonList}
          className="d-flex align-items-center justify-content-center"
        >
          <IconRight />
        </Button>
      </TippyDefault>

      <Switch view={view} />
    </ButtonSwitchViewWrapper>
  );
};

export default ButtonSwitchView;
